import { StronglyKeyedMap } from 'src/app/core/models/common.models';
import { PeriodEnum, PeriodMenuItem } from 'src/app/core/models/period';

export const PERIOD_NAMES: StronglyKeyedMap<PeriodEnum, string> = {
  lastYear: 'Last year',
  last3Months: 'Last 3 months',
  lastMonth: 'Last month',
  lastWeek: 'Last week',
  today: 'Today',
  custom: 'Custom',
};

export const PERIOD_MENU_ITEMS: readonly PeriodMenuItem[] = [
  {
    id: PeriodEnum.lastYear,
    name: PERIOD_NAMES.lastYear,
  },
  {
    id: PeriodEnum.last3Months,
    name: PERIOD_NAMES.last3Months,
  },
  {
    id: PeriodEnum.lastMonth,
    name: PERIOD_NAMES.lastMonth,
  },
  {
    id: PeriodEnum.lastWeek,
    name: PERIOD_NAMES.lastWeek,
  },
  {
    id: PeriodEnum.today,
    name: PERIOD_NAMES.today,
  },
  {
    id: PeriodEnum.custom,
    name: PERIOD_NAMES.custom,
  },
];
